import { createFragmentContainer, graphql } from "react-relay";
import JobEvent from "~/components/JobActivityTimeline/JobEvent";

type Props = {
  event: any;
  previousTimestamp: string | null | undefined;
};

function JobEventAgentLost({ event, previousTimestamp }: Props) {
  return (
    <JobEvent timestamp={event.timestamp} previousTimestamp={previousTimestamp}>
      <JobEvent.Label>Agent Lost</JobEvent.Label>
      <JobEvent.Description>
        The agent was lost and so the job was re-scheduled.
      </JobEvent.Description>
    </JobEvent>
  );
}

export default createFragmentContainer(JobEventAgentLost, {
  event: graphql`
    fragment JobEventAgentLost_event on JobEvent {
      ... on JobEvent {
        timestamp
      }
    }
  `,
});
